module.exports = __webpack_public_path__ + "img/169.c72ab10c.jpg";